import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InstantAccess } from './components/InstantAccess';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="28sbar1ybx15l">
      <MetaPixel data-id="element-1" data-mp="23vuoyeelqyvo" />
      <CountdownBar data-id="element-2" data-mp="23u9vks40xlze" />
      <main data-id="element-3" data-mp="23ut9lxqjzq85">
        <Hero data-id="element-4" data-mp="23t8fuac2cbbc" />
        <StatsBar data-id="element-5" data-mp="3ijxpqrsp22kf" />
        <Difference data-id="element-6" data-mp="3ikh7o8icgqyg" />
        <Recognize data-id="element-7" data-mp="3iiwfgpji5k3r" />
        <WhatsInside data-id="element-8" data-mp="3ijfunyhrpue3" />
        <InstantAccess data-id="element-9" data-mp="3ii4su47vuwpm" />
        <Bonuses data-id="element-10" data-mp="3mlaxj7fckftz" />
        <Offer data-id="element-11" data-mp="3mkrcviybbdc9" />
        <Guarantee data-id="element-12" data-mp="3mk85gw6ag7ch" />
        <Testimonials data-id="element-13" data-mp="3mjq45l4rr2xp" />
        <Faq data-id="element-14" data-mp="3rc9du70c5dx8" />
        <FinalCta data-id="element-15" data-mp="3rcj31sdk3h1v" />
      </main>
      <Footer data-id="element-16" data-mp="3rdkhm6ts6loc" />
      <PurchaseNotification data-id="element-17" data-mp="3rcsulke91w9o" />
    </div>;
}